// FE-3 : https://www.figma.com/file/rjvTEGNOs42Sv2L7TEA5Ef/DRC_%E6%A5%AD%E5%8B%99%E7%AE%A1%E7%90%86%E3%82%B7%E3%82%B9%E3%83%86%E3%83%A0_%E7%AE%A1%E7%90%86%E8%80%85%E7%94%A8?type=design&node-id=142-1227&mode=design&t=2R9y6hQCpN4l2bnM-0

import CreateUpdateForm from "../CreateUpdateForm";

function CreateTestPlanPage() {
  return <CreateUpdateForm isUpdate={false} />;
}

export default CreateTestPlanPage;
